import { Skeleton } from '@material-ui/lab';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const Loader = ({ className }) => {
  const styles = useStyles();

  return (
    <div className={cx(className, styles.root)}>
      <Skeleton
        variant="rect"
        className={styles.rect}
      />
      <Skeleton
        variant="rect"
        className={styles.rectSmall}
      />
    </div>
  );
};

Loader.propTypes = {
  className: PropTypes.string,
};

Loader.defaultProps = {
  className: null,
};
